import { useContextSelector } from "use-context-selector";
import { LocalParticipantContext } from "../context/LocalParticipantContext";

export const useLocalParticipant = () => {
  const audioOff = useContextSelector(LocalParticipantContext, (context) => context.audioOff);
  const videoOff = useContextSelector(LocalParticipantContext, (context) => context.videoOff);

  const handleAudio = useContextSelector(LocalParticipantContext, (context) => context.handleAudio);
  const handleVideo = useContextSelector(LocalParticipantContext, (context) => context.handleVideo);
  const setAudioOff = useContextSelector(LocalParticipantContext, (context) => context.setAudioOff);
  const setVideoOff = useContextSelector(LocalParticipantContext, (context) => context.setVideoOff);
  const localScreenTrack = useContextSelector(
    LocalParticipantContext,
    (context) => context.screenTrack
  );
  const sharingScreen = useContextSelector(
    LocalParticipantContext,
    (context) => context.sharingScreen
  );
  const handleShareScreen = useContextSelector(
    LocalParticipantContext,
    (context) => context.handleShareScreen
  );

  const networkQualityLevelLocal = useContextSelector(
    LocalParticipantContext,
    (context) => context.networkQualityLevelLocal
  );

  const setNetworkQualityLevelLocal = useContextSelector(
    LocalParticipantContext,
    (context) => context.setNetworkQualityLevelLocal
  );

  const handleChangeBackground = useContextSelector(
    LocalParticipantContext,
    (context) => context.handleChangeBackground
  );

  const showEffectsModal = useContextSelector(
    LocalParticipantContext,
    (context) => context.showEffectsModal
  );

  const setShowEffectsModal = useContextSelector(
    LocalParticipantContext,
    (context) => context.setShowEffectsModal
  );

  return {
    audioOff,
    videoOff,
    handleAudio,
    handleVideo,
    setAudioOff,
    setVideoOff,
    localScreenTrack,
    sharingScreen,
    showEffectsModal,
    handleShareScreen,
    setShowEffectsModal,
    networkQualityLevelLocal,
    setNetworkQualityLevelLocal,
    handleChangeBackground,
  };
};
